import Vue from 'vue'
Vue.prototype.imgUrl = 'https://xlkt.bjkmjs.com'
// Vue.prototype.imgUrl = 'http://health.babytuoyu.com'


// WEBPACK FOOTER //
// ./src/assets/js/common.js